import { render, staticRenderFns } from "./AdmittedList.vue?vue&type=template&id=0c4ff714"
import script from "./AdmittedList.vue?vue&type=script&lang=js"
export * from "./AdmittedList.vue?vue&type=script&lang=js"
import style0 from "./AdmittedList.vue?vue&type=style&index=0&id=0c4ff714&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports